import API_GATE from '../axios-instance';
import {
  Base64ImageReq,
  Base64ImageRes,
  RecognitionResultsResNew,
} from './scan-data-types';
import scanDataConfig from './scan-data-config';
import fetchData from '../fetch-data';

const serviceUrl = `${scanDataConfig.serviceName}/${scanDataConfig.path}`;

/// Распознование одной картинки в формате base64
export const base64ImageRecognition = fetchData<
  Base64ImageRes,
  // Base64ImageReq
  FormData
>(`${serviceUrl}/Base64Image`, API_GATE);

/// Распознование массива картинок в формате base64
export const base64ImageListsRecognition = fetchData<any, Base64ImageReq[]>(
  `${serviceUrl}/Base64ImageList`,
  API_GATE
);

export const recognitionResultChecker = fetchData<
  RecognitionResultsResNew,
  { SessionId: string }
>(`${serviceUrl}/Result`, API_GATE, 'get');
